import * as Yup from 'yup';

const DiscountSchema = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  description: Yup.string().required('Description is required'),
  startDate: Yup.date()
    .required('Start date is required')
    .min(new Date().toISOString().split('T')[0], 'Start date cannot be before today'),
  endDate: Yup.date()
    .required('End date is required')
    .min(Yup.ref('startDate'), 'End date cannot be before start date'),
  discountPercentage: Yup.number()
    .required('Discount percentage is required')
    .positive('Discount percentage must be positive')
    .lessThan(100, 'Discount percentage must be less than 100'),
  isOverEntireMenu: Yup.boolean(),
  categoryIds: Yup.array().nullable(),
  itemIds: Yup.array().nullable(),
});

export default DiscountSchema;